"use strict";

(() => {
  const TABLET_MAX = 991.98;
  const MOBILE_MAX = 767.98;

  function isOffersSliderEnabled() {
    return window.matchMedia(`(max-width: ${TABLET_MAX}px)`).matches;
  }

  function getVisibleSlidesCount() {
    if (!isOffersSliderEnabled()) {
      return 0;
    }

    if (window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches) {
      return 1;
    }

    return 2;
  }

  function getScrollAmount(viewport, track) {
    const firstSlide = track.querySelector(".offers__slide");

    if (!firstSlide) {
      return viewport.clientWidth;
    }

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;

    return firstSlide.getBoundingClientRect().width + gap;
  }

  function getSlideWidthValue(viewportWidth, gap, visibleSlides) {
    if (visibleSlides <= 1) {
      return `${viewportWidth}px`;
    }

    return `${(viewportWidth - gap * (visibleSlides - 1)) / visibleSlides}px`;
  }

  function resetSlideStyles(slides) {
    slides.forEach((slide) => {
      slide.style.removeProperty("flex");
      slide.style.removeProperty("max-width");
    });
  }

  function applyResponsiveSlidesWidth(viewport, track) {
    const slides = track.querySelectorAll(".offers__slide");
    const visibleSlides = getVisibleSlidesCount();

    if (!slides.length || !visibleSlides) {
      resetSlideStyles(slides);
      return;
    }

    const viewportWidth = viewport.clientWidth;

    if (!viewportWidth) {
      return;
    }

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
    const slideWidth = getSlideWidthValue(viewportWidth, gap, visibleSlides);

    slides.forEach((slide) => {
      slide.style.flex = `0 0 ${slideWidth}`;
      slide.style.maxWidth = slideWidth;
    });
  }

  function updateSliderNavigation(section) {
    const viewport = section.querySelector("[data-offers-viewport]");
    const track = section.querySelector("[data-offers-track]");
    const navigation = section.querySelector("[data-offers-navigation]");
    const prevButton = section.querySelector("[data-offers-prev]");
    const nextButton = section.querySelector("[data-offers-next]");
    const visibleSlides = getVisibleSlidesCount();
    const slides = track ? track.querySelectorAll(".offers__slide") : [];

    if (!viewport || !track || !navigation || !prevButton || !nextButton) {
      return;
    }

    const shouldShowNavigation =
      isOffersSliderEnabled() && slides.length > visibleSlides;

    navigation.hidden = !shouldShowNavigation;
    section.classList.toggle("is-slider-enabled", isOffersSliderEnabled());

    if (!shouldShowNavigation) {
      prevButton.disabled = true;
      nextButton.disabled = true;
      return;
    }

    const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    const currentScrollLeft = viewport.scrollLeft;

    prevButton.disabled = currentScrollLeft <= 1;
    nextButton.disabled = currentScrollLeft >= maxScrollLeft - 1;
  }

  function initOffersSection(section) {
    const viewport = section.querySelector("[data-offers-viewport]");
    const track = section.querySelector("[data-offers-track]");

    if (!viewport || !track) {
      return;
    }

    let resizeFrame = null;

    const syncSliderLayout = () => {
      applyResponsiveSlidesWidth(viewport, track);
      updateSliderNavigation(section);
    };

    if (section.dataset.offersSectionInitialized !== "true") {
      const prevButton = section.querySelector("[data-offers-prev]");
      const nextButton = section.querySelector("[data-offers-next]");

      if (prevButton && nextButton) {
        prevButton.addEventListener("click", () => {
          viewport.scrollBy({
            left: getScrollAmount(viewport, track) * -1,
            behavior: "smooth",
          });
        });

        nextButton.addEventListener("click", () => {
          viewport.scrollBy({
            left: getScrollAmount(viewport, track),
            behavior: "smooth",
          });
        });
      }

      viewport.addEventListener("scroll", () => {
        window.requestAnimationFrame(() => {
          updateSliderNavigation(section);
        });
      });

      window.addEventListener("resize", () => {
        if (resizeFrame) {
          window.cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = window.requestAnimationFrame(() => {
          syncSliderLayout();
        });
      });

      section.dataset.offersSectionInitialized = "true";
    }

    syncSliderLayout();
  }

  function initOffersSections(scope = document) {
    scope.querySelectorAll("[data-offers-section]").forEach((section) => {
      initOffersSection(section);
    });
  }

  window.offersSectionSliderUi = {
    init: initOffersSections,
  };

  document.addEventListener("DOMContentLoaded", () => {
    initOffersSections();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initOffersSections(event.target);
  });
})();
